/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PartnerRegion } from '../../models/partner-region';

export interface UpdatePartnerRegion$Params {
  id: string;
      body?: PartnerRegion
}

export function updatePartnerRegion(http: HttpClient, rootUrl: string, params: UpdatePartnerRegion$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerRegion>> {
  const rb = new RequestBuilder(rootUrl, updatePartnerRegion.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PartnerRegion>;
    })
  );
}

updatePartnerRegion.PATH = '/partnerregion/{id}';
